import "core-js/modules/esnext.global-this.js";
import './../external/ismobilejs/esm/index.mjs';
import isMobile$1 from './../external/ismobilejs/esm/isMobile.mjs';
var isMobile = isMobile$1(globalThis.navigator);
export { isMobile };